import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=2f212d68&scoped=true&"
import script from "./Today.vue?vue&type=script&lang=js&"
export * from "./Today.vue?vue&type=script&lang=js&"
import style0 from "./Today.vue?vue&type=style&index=0&id=2f212d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f212d68",
  null
  
)

export default component.exports